// extracted by mini-css-extract-plugin
export var passengerName = "jwtd67w_vL1uHLiXH6jr";
export var passengersList = "VdL9iO3Kz_tJKmiHMq7a";
export var ticketOptions = "nVCYmZ89pCwm7qGj5ahg";